module.exports = __webpack_public_path__ + "static/media/photos.a324e62c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/photos.png
// module id = 38
// module chunks = 0